module.exports = __webpack_public_path__ + "static/media/student-summary-round-prev.41c7b5e2.png";